<template>
  <div class="range-input">
    <div class="range-input__label">
      <slot name="label">{{ label }}</slot>
    </div>
    <div class="range-input__value">
      <slot name="measure">
        <component :currency="currency" :is="tag" :measure="displayMeasure" :num="displayValue"/>
      </slot>
    </div>
    <div class="range-input__input">
      <b-input
        :max="max"
        :min="min"
        :step="step"
        :value="value"
        @change="$emit('change', parseFloat($event))"
        @input="$emit('input', parseFloat($event))"
        class="price-input__pop-input"
        ref="input"
        size="sm"
        type="range"
      />
    </div>
  </div>
</template>

<script>
  import Price from "./Price";
  import Value from "./Value";
  import R, {isEmpty} from "ramda";
  import PopupInput from "./AerocreteCalculator/PopupInput";

  export default {
    name: "DefaultRangeInput",
    components: {
      PopupInput,
      Price,
      Value
    },
    inheritAttrs: false,
    props: {
      label: {
        type: String
      },
      value: {
        type: Number
      },
      step: {
        type: Number
      },
      min: {
        type: Number
      },
      max: {
        type: Number
      },
      currency: {
        type: Object,
        default: null
      },
      measure: {
        type: String
      },
      purchase: {
        type: Object,
        default: () => ({})
      },
    },
    computed: {
      tag() {
        if (this.currency) return 'price';
        else return 'value'
      },
      displayValue() {
        if (isEmpty(this.purchase)) return this.value;
        return this.value * this.purchase.multiplier;
      },
      displayMeasure() {
        if (isEmpty(this.purchase)) return this.measure;
        return this.purchase.measure;
      },
    },
    methods: {
      onKeyUp({key}) {
        const keyIs = (keyCode) => R.always(R.equals(key, keyCode));

        let value = R.compose(
          R.ifElse(isNaN, R.always(0), R.identity),
          R.ifElse(R.gt(0), R.always(0), R.identity),
          (num) => num.toFixed(2),
          parseFloat,
          R.cond([
            [keyIs('ArrowUp'), R.add(this.step)],
            [keyIs('ArrowDown'), R.subtract(R.__, 1)],
            [keyIs('ArrowRight'), R.identity],
            [keyIs('ArrowLeft'), R.identity],
            [R.always(true), R.identity]
          ])
        )(this.value);
        this.$emit('input', value);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .range-input {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-content: space-between;
    align-items: flex-start;

    &__label {
      font-style: normal;
      font-weight: normal;
      font-size: 0.875em;
      line-height: 1.5rem;
      flex: none;
    }

    &__value {
      font-style: normal;
      font-weight: 500;
      font-size: 1.125em;
      line-height: 1.5rem;
      text-align: right;
      flex: none;
    }

    &__input {
      width: 100%;
      flex: 1 1 auto;
    }
  }
</style>
